import React from "react";

import {useTranslation} from "react-i18next";
// import UsersTab from "./subpages/Users/index";
// import RolesMainPage from "@components/Dashboard/pages/SettingsPage/General/MyAccount/subpages/Roles/MainPage";
// import RolesCreationPage from "@components/Dashboard/pages/SettingsPage/General/MyAccount/subpages/Roles/CreationPage";
// import RolesEditingPage from "@components/Dashboard/pages/SettingsPage/General/MyAccount/subpages/Roles/CreationPage";
import BaseUnderconstruct from "@reusables/BaseUnderconstruct";
import Profile from "./subpages/Profile";
import BaseTabs from "@reusables/BaseTabs";


function MyAccountRouter() {
    const { t } = useTranslation("", { keyPrefix: "settings.general.myAccount.tabs" });

    return (
        <div className="levitation-extended w-full">
            <BaseTabs
                tabs={[
                    {
                        key: "profile",
                        title: t("profile.title"),
                        content: <Profile />
                    },
                    {
                        key: "billing",
                        title: t("billing.title"),
                        content: <BaseUnderconstruct />
                    },
                    {
                        key: "subscriptions",
                        title: t("subscriptions.title"),
                        content: <BaseUnderconstruct />
                    }
                ]}
            />
        </div>
    )
}


export default MyAccountRouter;
